import { render, staticRenderFns } from "./muestras.vue?vue&type=template&id=177f43aa&scoped=true"
import script from "./muestras.vue?vue&type=script&lang=js"
export * from "./muestras.vue?vue&type=script&lang=js"
import style0 from "./muestras.vue?vue&type=style&index=0&id=177f43aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f43aa",
  null
  
)

export default component.exports